import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route } from "react-router-dom";
import { FaroRoute } from '@grafana/faro-react';
import { FlagsProvider } from '@innovid/feature-flags-react';
// import Mocker from "utils/Mocker";

// TODO: This filename should change when you update your application
import Starter from "./Starter";
import config from "utils/appConfig";
import { getFeatureFlagsConfig } from "./featureFlag/featureFlag";

import "./App.css";

// Mocker();
let RouteMaker = Route;

if(config.grafanaURL){
	RouteMaker = FaroRoute;
}

export default function App(props){
	const featureFlagsConfig = getFeatureFlagsConfig();

	return (
		<Provider store={props.store}>
			<FlagsProvider config={featureFlagsConfig}>
				<ConnectedRouter history={props.history}>
					<RouteMaker path="/" component={Starter} />
				</ConnectedRouter>
			</FlagsProvider>
		</Provider>
	);
}
